"use client";
import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export function ThemeToggle() {
  const [theme, setTheme] = useState<"light" | "dark">("light");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const saved = (localStorage.getItem("finzone-theme") as "light" | "dark" | null) ?? null;
    const initial = saved ?? "dark"; // dark by default
    setTheme(initial);
    document.documentElement.setAttribute("data-theme", initial);
  }, []);

  function toggle() {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("finzone-theme", next);
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={theme === "dark" ? "Chuyển sáng" : "Chuyển tối"}
      className="inline-flex items-center justify-center w-7 h-7 rounded-full border hairline-strong transition-colors hover:bg-[var(--bg-2)]"
      style={{ color: "var(--ink-2)" }}
    >
      {mounted ? (theme === "dark" ? <Sun size={14} /> : <Moon size={14} />) : <Moon size={14} />}
    </button>
  );
}
